var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { EntityPermissionsType, } from '@common/api';
import Manager from '@shared/modal/Manager';
import React from 'react';
import DeleteRowModal from './modals/DeleteRow';
import EditRow from './modals/EditSheetRow';
import ShareModal from './modals/ShareModal';
import { startGlobalLoading, stopGlobalLoading } from '@shared/loading/globalLoading';
import toast from 'react-hot-toast';
import { Connection, Copy, Delete, Edit, Lock, Materialize, Paste, Share, ThreeDots, Unlock, } from '@shared/icons/icons';
import { Confirmation } from '@shared/modal/Simple';
import { EntryLinkModal } from '../../features/entry-links/EntryLinkModal';
import { ThreeStateCheckBox } from '@shared/input/CheckBox';
import { handleApiErrorMessage } from '../../util/message';
export function getMenuConfig(target, canManipulate, copyItem, setCopyItem, user, tagData, sheetRowsById, duplicateSheetRow, lockRows, lockRowsAndSubRows, L, finderColumns, classActions, materialize, actionsMap) {
    var _this = this;
    var _a, _b, _c, _d, _e;
    var isRoot = ((target === null || target === void 0 ? void 0 : target.parentId) === null || (target === null || target === void 0 ? void 0 : target.parentId) === 0) && target.id === null;
    var targetId = target === null || target === void 0 ? void 0 : target.id;
    var disabledUpdate = targetId !== null && !((_a = actionsMap === null || actionsMap === void 0 ? void 0 : actionsMap[targetId !== null && targetId !== void 0 ? targetId : 0]) === null || _a === void 0 ? void 0 : _a.canUpdate);
    var disabledDelete = targetId !== null && !((_b = actionsMap === null || actionsMap === void 0 ? void 0 : actionsMap[targetId !== null && targetId !== void 0 ? targetId : 0]) === null || _b === void 0 ? void 0 : _b.canDelete);
    var canDuplicate = ((_c = classActions.sheetRowClassActions) === null || _c === void 0 ? void 0 : _c.canDuplicate) === true;
    var tag = (_d = tagData.tagById) === null || _d === void 0 ? void 0 : _d[(_e = target === null || target === void 0 ? void 0 : target.generatedTagId) !== null && _e !== void 0 ? _e : 0];
    var currentRow = targetId ? sheetRowsById[targetId] : null;
    var share = function () {
        targetId && Manager.renderModal(React.createElement(ShareModal, { targetId: targetId, entity: EntityPermissionsType.SheetRow }));
    };
    var edit = function () {
        if (targetId) {
            Manager.renderModal(React.createElement(EditRow, { sheetRowId: targetId }));
        }
    };
    var copy = function () {
        targetId && setCopyItem({ id: targetId });
    };
    var paste = function () { return __awaiter(_this, void 0, void 0, function () {
        var loadingId, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(targetId !== undefined && copyItem)) return [3 /*break*/, 6];
                    loadingId = void 0;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 5, 6]);
                    loadingId = toast.loading('Copying rows...');
                    return [4 /*yield*/, duplicateSheetRow({ id: copyItem.id, targetId: targetId })];
                case 2:
                    _a.sent();
                    toast.success('Rows copied!');
                    return [3 /*break*/, 6];
                case 3:
                    error_1 = _a.sent();
                    return [4 /*yield*/, handleApiErrorMessage(error_1)];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    toast.dismiss(loadingId);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var del = function () {
        targetId && Manager.renderModal(React.createElement(DeleteRowModal, { targetId: targetId }));
    };
    var confirmLockUnlock = function (clsId, newValue) {
        Manager.renderModal(React.createElement(Confirmation, { width: 400, title: React.createElement("span", null, L("Confirm ".concat(newValue ? 'lock' : 'unlock'))), onOk: function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            startGlobalLoading();
                            return [4 /*yield*/, lockRowsAndSubRows([clsId], newValue)];
                        case 1:
                            _a.sent();
                            stopGlobalLoading();
                            return [2 /*return*/];
                    }
                });
            }); } },
            React.createElement("span", null,
                L("Are you sure you want to ".concat(newValue ? 'lock' : 'unlock', " this row and its children")),
                "?")));
    };
    var createEntryLink = function () {
        var e_1, _a;
        if (!target || !target.id) {
            return;
        }
        if (tag && tag.ParentId && target.parentId !== undefined) {
            var column = finderColumns.find(function (c) { var _a; return (_a = c.clusterId === target.parentId) !== null && _a !== void 0 ? _a : 0; });
            var dimensionTagIds = column === null || column === void 0 ? void 0 : column.items.filter(function (i) { return i.parentTagId === tag.ParentId; }).map(function (i) { return i.tagId; });
            var filterTagIds = [];
            var clustersTags = target === null || target === void 0 ? void 0 : target.path.split('_');
            try {
                for (var _b = __values(clustersTags !== null && clustersTags !== void 0 ? clustersTags : []), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var ct = _c.value;
                    var splat = ct.split(':');
                    if (splat.length === 2) {
                        var _d = __read(splat, 2), tagId = _d[1];
                        filterTagIds.push(Number(tagId));
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            Manager.renderModal(React.createElement(EntryLinkModal, { path: target.path, tableTagId: tag.ParentId, filterTagIds: filterTagIds, filteredDimensionTagIds: dimensionTagIds }));
            return;
        }
        Manager.renderModal(React.createElement(EntryLinkModal, { path: target.path }));
    };
    var entryLinkItems = user.features.canSeeEntryLinks
        ? [
            {
                icon: Connection,
                actionName: L('Create Entry Link'),
                isDisabled: !targetId || !user.classActions.dataEntryLinkActions.canCreate,
                action: createEntryLink,
            },
        ]
        : [];
    var menuItems = [
        {
            icon: Edit,
            actionName: L('Edit'),
            isDisabled: disabledUpdate || !canManipulate,
            action: edit,
        },
        {
            icon: Copy,
            actionName: L('Copy'),
            isDisabled: !canDuplicate || !canManipulate,
            action: copy,
        },
        {
            icon: Paste,
            actionName: L('Paste'),
            isDisabled: !copyItem || !canDuplicate || disabledUpdate,
            action: paste,
        },
        {
            icon: Share,
            actionName: L('Share'),
            isDisabled: disabledUpdate || isRoot,
            action: share,
        },
        { spacer: true },
        {
            isDisabled: disabledUpdate || !canManipulate || !currentRow,
            Component: function (props) { return (React.createElement(ThreeStateCheckBox, { value: (currentRow === null || currentRow === void 0 ? void 0 : currentRow.readonly) || false, action: function () {
                    if (currentRow) {
                        lockRows([currentRow.id], !currentRow.readonly);
                    }
                }, label: L(L('Lock Row')), css: { width: '100%', paddingLeft: 10 }, labelStyle: { padding: '0px 8px' } })); },
        },
        { spacer: true },
        {
            icon: ThreeDots,
            actionName: L('More Options'),
            items: __spreadArray(__spreadArray([
                {
                    icon: Materialize,
                    actionName: L('Materialize'),
                    isDisabled: !user.isSuperUser,
                    action: materialize,
                }
            ], __read(entryLinkItems), false), [
                { spacer: true },
                {
                    icon: Lock,
                    actionName: L('Lock Hierarchy'),
                    isDisabled: disabledUpdate || !canManipulate || !currentRow,
                    action: function () {
                        if (targetId) {
                            confirmLockUnlock(targetId, true);
                        }
                    },
                    destructive: true,
                },
                {
                    icon: Unlock,
                    actionName: L('Unlock Hierarchy'),
                    isDisabled: disabledUpdate || !canManipulate || !currentRow,
                    action: function () {
                        if (targetId) {
                            confirmLockUnlock(targetId, false);
                        }
                    },
                    destructive: true,
                },
            ], false),
        },
        { spacer: true },
        {
            icon: Delete,
            actionName: L('Delete'),
            isDisabled: disabledDelete || !canManipulate,
            destructive: true,
            action: del,
        },
    ];
    return __spreadArray([], __read(menuItems), false);
}
